import { render, staticRenderFns } from "./self_score.vue?vue&type=template&id=616471ba&"
import script from "./self_score.vue?vue&type=script&lang=js&"
export * from "./self_score.vue?vue&type=script&lang=js&"
import style0 from "./self_score.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports